import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ImageUtilService } from '../../shared/image-util-service/image-util.service';
import { ImageAsDataUrl } from '../../shared/image-util-service/image-as-data-url';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lp2-message-bubble',
  templateUrl: './message-bubble.component.html',
  styleUrls: ['./message-bubble.component.scss'],
})
export class MessageBubbleComponent implements OnInit, OnDestroy {
  @Input() name: string;
  @Input() date: number;
  @Input() text: string[];
  @Input() title: string;
  @Input() subTitle: string;
  @Input() isSenderDisplayed = true;
  @Input() sentByPersonId: number;
  @Input() isLeftStyle = true;

  avatar: ImageAsDataUrl = { image: null };
  avatarHeightWidth = 42;
  subscription: Subscription;

  constructor(private imageUtilService: ImageUtilService) {}

  ngOnInit(): void {
    if (!this.isSenderDisplayed) {
      return;
    }
   this.subscription = this.imageUtilService
      .getProfilePicAsDataUrl(this.avatar, this.avatarHeightWidth, this.avatarHeightWidth, this.sentByPersonId)
      .subscribe(() => {});
  }

  ngOnDestroy(): void {
      this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./ts/app/teacher-feedback/message-bubble/message-bubble.component.ts